import { ChangeEvent, useState } from 'react'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { PostSheetsUpload } from '../../services/PlanilhasVendas/postSheets'

export const useSpreadSheet = () => {
  const [importFile, setImportFile] = useState<File | null>(null)

  const navigate = useNavigate()

  const goToPage = (url: string) => {
    navigate(url)
  }

  const isValidFile = importFile && importFile.name.endsWith('.xlsx')

  const handleSetImport = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const file = target.files?.[0] || null
    if (file?.name.endsWith('.xlsx')) setImportFile(file)
    else toast.error('Arquivo inválido')
    // eslint-disable-next-line no-param-reassign
    target.value = ''
  }

  const handleUploadSheets = async (multipartFile: File) => {
    const result = await PostSheetsUpload(multipartFile)

    if ('info' in result) {
      goToPage('/planilhas-sucesso')

      return
    }
    // eslint-disable-next-line consistent-return
    return goToPage('/planilhas-error')
  }
  return {
    handleSetImport,
    importFile,
    isValidFile,
    handleUploadSheets,
  }
}
